// extracted by mini-css-extract-plugin
export default {"editorWrapper":"RichTextInput_editorWrapper__y2t1u","hasError":"RichTextInput_hasError__XfVnC","resizeHandleIcon":"RichTextInput_resizeHandleIcon__dd+pS"};